export { default } from './redirect';
